import { useQuery } from 'react-query'

export default () => {
  const { data: donorContactInformation } = useQuery('GetDonorContactInformation', () =>
    axios.get('/api/get-donor-contact-information').then(
      (response) => response.data.data.filter((x) => x), // remove hidden fields, these are sent with the value false
    ),
  )

  return donorContactInformation || []
}
